'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StepBorder = function (_React$Component) {
  (0, _inherits3.default)(StepBorder, _React$Component);

  function StepBorder() {
    (0, _classCallCheck3.default)(this, StepBorder);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(StepBorder).apply(this, arguments));
  }

  (0, _createClass3.default)(StepBorder, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var defaultStyle = _props.defaultStyle;
      var contentHeight = _props.contentHeight;

      var height = contentHeight + 48 + 28 + 24 + 15;
      var styles = (0, _extends3.default)({}, defaultStyle, { height: height });
      return _react2.default.createElement('div', { style: styles });
    }
  }]);
  return StepBorder;
}(_react2.default.Component);

StepBorder.defaultProps = {
  defaultStyle: {
    position: 'absolute',
    left: 0,
    width: '1px',
    backgroundColor: 'rgba(0,0,0,.1)',
    margin: '-25px 4px 0 37px'
  }
};

StepBorder.propTypes = {
  defaultStyle: _react2.default.PropTypes.object
};

exports.default = StepBorder;


//////////////////
// WEBPACK FOOTER
// ./~/react-mdl-stepper/dist/step_border.js
// module id = 828
// module chunks = 0